export default __webpack_public_path__ + "static/media/team2.0368ad9c.png";